<template>
<div :class="$style.container" class="center">
    <div style="height:11%;" ></div>
    <div :class="$style.box" class="center dib">
        <logo :height="42" style="margin-top: 50px;"></logo>
        <p class="fw500 fs24" style="margin-top:10px;">{{$t('su1')}}</p>
        <p class="gray fs12">{{$t('su2')}}</p>
        <div style="width: 80%;margin: 20px auto;" class="blueinput">
            <el-input v-model="model.name" :placeholder="$t('fn')"></el-input>
            <el-input v-model="model.surname" :placeholder="$t('ln')" style="margin-top:25px"></el-input>
			<el-input v-model="model.email" :placeholder="$t('email')" style="margin-top:25px;margin-bottom: 25px;"></el-input>
            <div class="dflex pr">
                <span v-if="codeErr" class="red pa" style="right: 0px;bottom: -25px;">{{ codeErr }}</span>
                <!-- <el-input v-model="areaCode" :placeholder="$t('areaCode')" style="width: 40%; padding-right: 10px;"></el-input> -->
                <el-select v-model="areaCode" :placeholder="$t('areaCode')" style="width: 40%; padding-right: 10px;">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-input v-model="phone" :placeholder="$t('phone1')"></el-input>
            </div>
            <el-input v-model="model.code" :placeholder="$t('certify')" style="margin-top:25px;width: calc(100% - 140px);" class="dib"></el-input>
            <el-button type="primary" :disabled="!canSendCertify" @click="getCertify" style="width: 130px;
    padding: 12px 0px;margin-left:10px;">{{ time > 0 ? time : $t('getCertify') }}</el-button>
            <el-input v-model="model.password" show-password :placeholder="$t('password')" style="margin-top:25px;margin-bottom: 25px;"></el-input>
            <p class="gray left" style="margin-bottom: 10px;">
                <el-checkbox v-model="checked">{{$t('su3')}}
                    <span class="cp link1" @click="$router.push('/termPersonal')">{{$t('tac')}}</span>
                </el-checkbox>
            </p>
            <p v-if="err" class="red">{{err}}</p>
            <el-button type="primary" style="padding: 14px; width: 100%;" @click="onSignupClick" :disabled="!canSubmit">{{ $t('su4') }}</el-button>
        </div>
        <div class="left gray" style="font-size: 12px;margin:40px 45px;">
            <p>
                {{$t('su5')}} <span class="blue cp" @click="$router.push('/signin')">{{$t('signin')}}</span>
            </p>
            <p> <span class="blue cp" @click="toDomestic">{{$t('domesticsignup')}}</span></p>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'Signup',
    data() {
        return {
            checked: false,
            areaCode: '852',
            phone: '',
            model: {
                name: '',
                surname: '',
                mobile: '',
                password: '',
                code: '', // 短信驗證碼
                code_id: '',
				email: '',
            },
            time: 0,
            err: '',
            codeErr: '',
            options: [{label: '852', value: '852'}]
        };
    },
    computed: {
        canSendCertify() {
            return this.areaCode && this.phone && this.time <= 0;
        },
        canSubmit() {
            return this.checked && this.model.name && this.model.surname && this.phone && this.areaCode && this.model.password && this.model.email;
        },
    },
    methods: {
        getCertify() {
            this.codeErr = '';
            this.countTime();
			var name1 = this.name || '';
			var name2 = this.surname || '';
			var name = '';
			if (name1 != '' && name2 == ''){
				name = this.name + ' ' + this.surname
			}
            this.$service.getCode({
                mobile: this.areaCode + this.phone,
				category: "register",
				name: name
            }).then((res) => {
                this.model.code_id = res.data.code_id;
            }).catch((err) => {
                this.codeErr = err.message;
            })
        },
        countTime() {
            this.time = 300;
            const fun = () => {
                if (this.time > 0) {
                    setTimeout(() => {
                        this.time = this.time - 1;
                        fun();
                    }, 1000);
                }
            };
            fun();
        },
		checkEmail(email){
			const regEmail = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
			if (regEmail.test(email)){
				return true;
			}
			return false;
		},
        onSignupClick() {
			this.err = '';
			if(!this.checkEmail(this.model.email)){
				this.err = 'Please enter the correct email address';
				return
			}
            this.model.mobile = this.phone;
            this.model.icnb = this.areaCode;
            this.$service.register(this.model).then(() => {
                this.$router.push('/signin');
            }).catch((err) => {
                this.err = err.message;
            });
        },
        toDomestic() {
            window.location = 'https://www.goldenwin.com.hk/helper/register';
        }
    }
}
</script>
<style module>
.container {
    height: 100%;
    background: url(../assets/signin.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}
.box {
    background: #fff;
    width: 40%;
    min-width: 339px;
    margin: 0px auto;
    opacity: 0.96;
}

</style>
